import {
  PayeeRequirement,
  PayeeRequirementExpirationStatus,
  PayeeRequirementExpirationStrategy,
  PayeeRequirementPayerOverrideStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Projects the renewal view: the requirement with its expiring (replaced)
 * snapshot's fields layered on top. The SDK duplicates the status/strategy
 * enums for the replaced snapshot (`ReplacedPayeeRequirement*`) with
 * identical wire values — the casts here bridge that nominal split in one
 * place.
 */
export const selectorRequirementWithReplacedSnapshot = (
  requirement: PayeeRequirement
): PayeeRequirement => {
  const replaced = requirement.replacedRequirement;

  if (!replaced) {
    return requirement;
  }

  return {
    ...requirement,
    dataSourceStatus: replaced.dataSourceStatus,
    dataSourceId: replaced.dataSourceId,
    dataSourceMetadata: replaced.dataSourceMetadata ?? undefined,
    payerOverrideStatus: replaced.payerOverrideStatus as unknown as
      | PayeeRequirementPayerOverrideStatus
      | null
      | undefined,
    status: replaced.status,
    expirationStrategy: replaced.expirationStrategy as unknown as
      | PayeeRequirementExpirationStrategy
      | null
      | undefined,
    dataSourceExpiresAt: replaced.dataSourceExpiresAt,
    strategyExpiresAt: replaced.strategyExpiresAt,
    payerOverrideExpiresAt: replaced.payerOverrideExpiresAt,
    expiresAt: replaced.expiresAt,
    expirationStatus: replaced.expirationStatus as unknown as
      | PayeeRequirementExpirationStatus
      | null
      | undefined
  };
};
